/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ScrollAwareContext, ScrollAwareScroller, ScrollAwareAppNavStep } from '../../components/ScrollAware';
import { AppHeaderScrollableText } from '../../components/appNav/AppHeaderScrollable';
import ContentFrame from '../../applicationFrame/ContentFrame';
import ContentWrapper from '../../components/ContentWrapper';
import Card, { CardSection } from '../../components/card/Card';
import AppUtils from '../../../utilities/AppUtils';
import { removeSignupPresented } from '../../../utilities/MobileUtil';

const ConfirmDelete = () => (
  <div>
    <ScrollAwareContext>
      <ScrollAwareAppNavStep
        color="white"
        done={() => {
          AppUtils.logout({}, () => {
            if (IS_ANDROID_BUILD) {
              removeSignupPresented(() => {
                AppUtils.reloadApp();
              });
            } else {
              window.location = 'https://backpackhealth.com';
            }
          });
        }}
      />

      <ContentFrame>
        <ScrollAwareScroller>
          <AppHeaderScrollableText
            id="deleteAccountSuccess.title.text"
          />
          <ContentWrapper>
            <Card>
              <CardSection>
                <div className="font-subhead font-color-gsDark">
                  <FormattedMessage id="deleteAccountSuccess.deleteSuccess.message.text" />
                </div>
              </CardSection>
            </Card>
          </ContentWrapper>
        </ScrollAwareScroller>
      </ContentFrame>
    </ScrollAwareContext>
  </div>
);

export default ConfirmDelete;
